import React from "react";

const MAP = {
  pending: { cls: "tag-pending", label: "Avventer" },
  approved: { cls: "tag-approved", label: "Godkjent" },
  rejected: { cls: "tag-rejected", label: "Avvist" },
  sick: { cls: "tag-sick", label: "Syk" },
  withdrawn: { cls: "tag-withdrawn", label: "Frafall" },
};

export default function StatusBadge({ status }) {
  const v = MAP[status] || MAP.pending;
  return (
    <span data-testid={`status-${status}`} className={`inline-block text-xs uppercase font-heading tracking-widest px-2 py-1 ${v.cls}`}>
      {v.label}
    </span>
  );
}
